import axios from "axios";
import { IP } from "../index.js";
/* 意见反馈 */
export async function selectFankui() {
  var resp = await axios.post(`${IP}/admin/fankui/select`, {});
  return resp.data;
}


export async function deleteFankui(id) {
  var resp = await axios.post(`${IP}/admin/fankui/delete`, { id });
  return resp.data;
}
